import axios from "axios";
import { DataResponse, PaginatedResponse } from "models/common/responseObjects";
import { ManagedSupplier } from "models/dbModels/managedSuppliers/ManagedSupplier";
import { ManagedSuppliersSearchFilterQuery } from "models/filters/managedSuppliers/ManagedSuppliersSearchFilterQuery";

export class ManagedSuppliersApi {
    static Search = async (query: ManagedSuppliersSearchFilterQuery) => axios.post<PaginatedResponse<ManagedSupplier[]>>(`api/v1/ManagedSuppliers/Search`, query);
    static Add = async (query: ManagedSupplier[]) => axios.post<DataResponse<number[]>>(`api/v1/ManagedSuppliers/Add`, query);
    static Update = async (query: ManagedSupplier[]) => axios.post<DataResponse<boolean>>(`api/v1/ManagedSuppliers/Update`, query);
    static Delete = async (query: ManagedSuppliersSearchFilterQuery) => axios.delete<DataResponse<boolean>>(`api/v1/ManagedSuppliers/Delete`, { data: query });
}